import { Controller } from '@hotwired/stimulus';
import { getBody } from '../utilities/browser/dom';
import { onPropertyTransitionEndOnce } from '../utilities/browser/events';
import { getNextModalZIndex, hasOpenModals, registerModal, unregisterModal } from '../utilities/modal';

export default class extends Controller {
    static values = {
        backdropClose: {
            type: Boolean,
            default: true,
        },
        removeOnClose: Boolean,
        autoOpen: {
            type: Boolean,
            default: false,
        }
    };

    initialize() {
        // Property used to track modal open via getModalByUrl
        this._openedByUrl = null;
    }

    connect() {
        if (this.element.classList.contains('dom-modal')) {
            registerModal(this);

            this.element.addEventListener('click', (event) => {
                if (this.backdropCloseValue && event.target.classList.contains('dom-modal')) {
                    this.close();
                }
            });

            if (this.autoOpenValue) {
                setTimeout(() => {
                    this.open();
                }, 1000);
            }
        }
    }

    disconnect() {
        unregisterModal(this);
    }

    get isOpen() {
        return this.element.classList.contains('open');
    }

    get modalId() {
        return this.element.getAttribute('id');
    }

    get openedByUrl() {
        return this._openedByUrl;
    }

    open() {
        if (this.isOpen) {
            return;
        }

        this.element.style.zIndex = getNextModalZIndex();
        getBody().classList.add('modal-active');
        // TODO Too buggy with different scroll containers, or initial padding on the container
        // getScrollContainer().style.paddingRight = `${getScrollbarWidth()}px`;

        this.element.classList.add('modal-in');
        requestAnimationFrame(() => {
            // Reset scroll to top, does not work on close when the modal is hidden
            this.element.scrollTop = 0;

            this.element.classList.add('open');
        });
    }

    closeAndReload() {
        this.close();

        location.reload();
    }

    close(e) {
        e.preventDefault();

        if (!this.element || !this.isOpen) {
            return;
        }

        onPropertyTransitionEndOnce(this.element, 'opacity', () => {
            this.element.classList.remove('modal-in');

            if (!hasOpenModals()) {
                getBody().classList.remove('modal-active');
                // TODO Too buggy with different scroll containers, or initial padding on the container
                // getScrollContainer().style.paddingRight = '';
            }

            if (this.removeOnCloseValue) {
                this.element.remove();
            } else {
                this.reset();
            }
        });
        this.element.classList.remove('open');
    }

    reset() {
        this.element.querySelectorAll('form').forEach((form) => {
            form.reset();
        });
    }
}
